var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerPage"},[_c('div',{staticClass:"backTop flex-rowc",on:{"click":_vm.backTop}},[_vm._v("Back to Top")]),_c('div',{staticClass:"copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }